import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../../../constants/schema";
import { useErrorHandler } from "../../../../../hooks";
import DialogFormBuilder from "../../../../../components/dialog-form-builder";
import PageBuilderRowService from "../../../../../services/page-builder-row.service";

const initialValues = {
    title: "",
    destinationURL: "",
    image: "",
};

const schema = Yup.object().shape({
    title: yupSchema.title,
    destinationURL: yupSchema.destinationURL,
    image: yupSchema.image,
});


const form = [
    {
        _type: "textField",
        name: "title",
        label: "عنوان",
        autoFocus: true,
    },
    {
        _type: "textField",
        name: "destinationURL",
        label: "آدرس مقصد",
    },
    {
        _type: "filePicker",
        name: "image",
        label: "عکس",
        isImage: true,
    },
];

export default function FormModalContent(props) {


    const { close, data, parent } = props;

    const errorHandler = useErrorHandler();

    const handleSubmit = async (model, { setSubmitting }) => {
        let op;
        if (data?.id) {
            op = await PageBuilderRowService.editPageBuilderRowContent(parent.id, data.index, model);
        } else {
            op = await PageBuilderRowService.createPageBuilderRowContent(parent.id, model);
        }
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    return (
        <DialogFormBuilder
            {...{
                close,
                name: "محتوا",
                data,
                schema,
                initialValues,
                handleSubmit,
                form,
            }}
        />
    );
}
